import { getCookie } from '@client/helpers/cookie';
const ACQUIRE_MODAL_VERSION = 'zl_acquire_modal_version';

export const isNewAcquireModal = () => {
    if (typeof window === 'undefined') {
        return false;
    }

    const acquireModalVersion = getCookie(ACQUIRE_MODAL_VERSION);

    return acquireModalVersion === 'v2';
};
